export default __webpack_public_path__ + "static/media/LifeChronicle.8d6d26f8d3180d2e1cfbdd94e3d83706.webp";